import React, { FC, useState } from 'react'
import { Button, Modal } from '@pepper/ui'
import format from 'date-fns/format'
import clsx from 'clsx'
import { X, Info, ChevronDown, ChevronUp, ArrowRight } from 'react-feather'
/* @pepper/utils */
import { getReadableAmount } from '@pepper/utils/src/function/currency'

import styles from '../_.module.css'

interface Props {
  projectCategory: string
  vertical: string
  totalPrice: PayScale
  assignmentList: AssignmentListFormValues[]
  orderId: string
  placedAt: string
  displayRazorPay: () => void
}

const PaymentFailed: FC<Props> = ({
  displayRazorPay,
  placedAt,
  projectCategory,
  vertical,
  assignmentList,
  totalPrice,
  orderId,
}) => {
  const [showFailed, toggleShowFailed] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const itemsList: { title: string; value: string }[] = [
    {
      title: 'Payment / Order ID:',
      value: orderId,
    },
    {
      title: 'Time & Date:',
      value: format(new Date(placedAt), `MMMM d, yyyy	'at' hh:mm a`),
    },
    {
      title: 'Order Category:',
      value: projectCategory,
    },
    {
      title: 'Content Type:',
      value: vertical,
    },
    {
      title: 'Item Quantity:',
      value: `${assignmentList.length} ${vertical}`,
    },
    {
      title: 'Total To Be Paid:',
      value: getReadableAmount(totalPrice),
    },
  ]
  const errorList = (
    <div>
      {itemsList.map(item => (
        <div key={item.title} className={styles.paymentFailedDetails}>
          <div className={styles.label}>{item.title}</div>
          <div className={styles.value}>{item.value}</div>
        </div>
      ))}
    </div>
  )
  return (
    <div>
      <div className={styles.retryWrap}>
        <div className={styles.retryInfo}>
          <Info className={styles.retryIcon} />
          <div className={styles.retryTexts}>
            <span className={styles.retryText}>
              We were unable to process your last payment.
            </span>
            <span
              role="none"
              onClick={() => setShowModal(true)}
              className={styles.retryView}
            >
              View Details
            </span>
          </div>
        </div>
        <div className={styles.payBtnWrap}>
          <Button className={styles.payTexts} onClick={displayRazorPay}>
            Retry Payment
            <ArrowRight className={styles.payIcon} />
          </Button>
        </div>
      </div>
      <Modal
        visible={showModal}
        wrapClassName={styles.createProjectWrap}
        cancelText="Close"
        okText="Retry Payment"
        cancelButtonProps={{
          type: 'link',
        }}
        onOk={() => {
          setShowModal(false)
          displayRazorPay()
        }}
        onCancel={() => setShowModal(false)}
      >
        <>
          <div className={styles.failedHeaderWrap}>
            <span className={styles.failedHeader}>Payment Details</span>
            <X
              onClick={() => setShowModal(false)}
              className={styles.closeHeader}
            />
          </div>
          {errorList}
        </>
      </Modal>
      <div
        role="none"
        onClick={() => toggleShowFailed(showFailed => !showFailed)}
        className={styles.qsnFailed}
      >
        Why did the payment fail?
        {showFailed ? (
          <ChevronUp className={styles.qsnIcon} />
        ) : (
          <ChevronDown className={styles.qsnIcon} />
        )}
      </div>
      <div
        className={clsx(styles.whyFailedAns, {
          [styles.showFailed]: showFailed,
        })}
      >
        <ul>
          <li className={styles.failReasons}>
            This usually happens when the payment gateway timeouts your request
          </li>
          <li className={styles.failReasons}>
            The timeout occurs when you either enter wrong payment information
            or run into a server related issue
          </li>
        </ul>
      </div>
    </div>
  )
}

export default PaymentFailed
